export const actions = {

  async fetchReportImage({ commit },code) {
    try {
      const response = await this.$axios.get(`/webpos/report-content/${code}/images`, {
        responseType: 'blob'
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching general logo:', error);
      return null;
    }
  }
}
